import { Component, OnInit } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl, Validators } from '@angular/forms';
import { ValidatorService } from 'app/core/service/app/validator.service';

@Component({
  selector: 'app-lessor-form',
  templateUrl: './lessor-form.component.html',
  styleUrls: ['./lessor-form.component.scss']
})
export class LessorFormComponent extends FormBaseComponent<any> implements OnInit {

  constructor(private validatorService: ValidatorService) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  template() {
    this.form.addControl('name', new FormControl(''));
    this.form.addControl('secondName', new FormControl(''));
    this.form.addControl('lastNamePaternal', new FormControl(''));
    this.form.addControl('lastNameMaternal', new FormControl(''));
    this.form.addControl('phone1', new FormControl(null, [this.validatorService.telefono]));
    this.form.addControl('phone2', new FormControl(null, [this.validatorService.telefono]));
    this.form.addControl('cellPhone', new FormControl(null, [this.validatorService.celular]));
    this.form.addControl('socialRazon', new FormControl(null));
    this.form.addControl('rfc', new FormControl(null));
    this.form.addControl('email', new FormControl(null, [Validators.email]));
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/lessor-form/lessor-form.component.ts